<script setup lang="ts">
defineProps<{
  title: string;
  links: { label: string; route: string }[];
}>();

const isDropdownOpen = ref(false);

const { isMinimumLg } = useScreenSize();
const localePath = useLocalePath();
</script>

<template>
  <div
    class="base-dropdown"
    @mouseenter="isMinimumLg ? (isDropdownOpen = true) : undefined"
    @mouseleave="isDropdownOpen = false"
    @focusin="isDropdownOpen = true"
    @blur="isDropdownOpen = false"
  >
    <BaseButton
      class="base-dropdown__button"
      @click="isDropdownOpen = !isDropdownOpen"
    >
      <span>{{ title }}</span>
      <BaseAnimatedChevronIcon
        class="base-dropdown__button__icon"
        :direction="isDropdownOpen ? 'up' : 'down'"
      />
    </BaseButton>
    <Transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="isDropdownOpen"
        class="base-dropdown__dropdown"
      >
        <NuxtLink
          v-for="link in links"
          :key="link.label + link.route"
          :to="localePath(link.route)"
          class="base-dropdown__dropdown__option interaction-dark"
        >
          {{ link.label }}
        </NuxtLink>
      </div>
    </Transition>
  </div>
</template>

<style scoped lang="postcss">
.base-dropdown {
  @apply relative pb-1 w-fit;
  &__button {
    @apply flex items-center justify-between gap-x-3;
    @apply py-3 md:py-2;
    &__icon {
      @apply w-5 h-5;
    }
  }
  &__dropdown {
    background-color: rgba(var(--color-1-rgb), 0.9);
    @apply text-platform-color-2 absolute left-0 z-20 mt-1 -mr-1 w-56 origin-top-right shadow-lg;

    &__option {
      @apply overflow-hidden;
      @apply block border-platform-color-1 border px-4;
      @apply py-3 md:py-2;
    }
  }
}
</style>
